import { render, staticRenderFns } from "./Projects.vue?vue&type=template&id=3bfedcea&"
import script from "./Projects.vue?vue&type=script&lang=ts&setup=true&"
export * from "./Projects.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./Projects.vue?vue&type=style&index=0&id=3bfedcea&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports